import React from 'react';
import { X, Loader2 } from 'lucide-react';

const ProjectsListModal = ({ isOpen, onClose, projects = [], isLoading = false }) => {
  if (!isOpen) return null;

  // Helper function to get project logo
  const getProjectLogoPath = (projectName) => {
    // Extract the highway number (e.g., "A65" from "A65 FDE AS Haßloch")
    const match = projectName.match(/A\d+/);
    const projectNumber = match ? match[0] : "placeholder";
    return `/logos/${projectNumber}.png`;
  };

  // Helper function to format CO2 text with subscript
  const formatCO2 = (text) => {
    return text.replace('CO2e/t', 'CO<sub>2</sub>e/t');
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-2xl max-h-[80vh] relative flex flex-col">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold">Alle Projekte</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 transition-colors"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        <div className="overflow-y-auto flex-grow">
          {isLoading ? (
            <div className="flex flex-col items-center justify-center py-8">
              <Loader2 className="h-8 w-8 animate-spin text-green-600 mb-2" />
              <p className="text-gray-700">Daten werden geladen...</p>
            </div>
          ) : (
            <div className="space-y-4">
              {projects.map((item, index) => (
              <div key={index} className="flex items-center justify-between p-3 hover:bg-gray-50 rounded-md">
                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center overflow-hidden flex-shrink-0 border border-gray-200">
                    <img
                      src={getProjectLogoPath(item.name)}
                      alt={item.name}
                      className="w-8 h-8 object-contain"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = `/api/placeholder/32/32`;
                      }}
                    />
                  </div>
                  <div>
                    <div>
                      {(() => {
                        // Match highway number followed by FDE or FDI
                        const match = item.name.match(/(A\d+\s+(?:FDE|FDI))/i);
                        if (match) {
                          // Use the first capture group as the first part (A65 FDE)
                          const firstPart = match[1];
                          // Use everything after the project code as the second part
                          const secondPartIndex = item.name.indexOf(firstPart) + firstPart.length;
                          const secondPart = item.name.substring(secondPartIndex);
                          return (
                            <>
                              <div className="font-medium">{firstPart}</div>
                              <div className="text-sm text-gray-500">{secondPart}</div>
                            </>
                          );
                        } else {
                          return <div className="font-medium">{item.name}</div>;
                        }
                      })()}
                    </div>
                    <div className="text-sm text-green-600" dangerouslySetInnerHTML={{ __html: formatCO2(`${item.purchases} kg CO2e/t`) }} />
                  </div>
                </div>
                <div className="font-medium whitespace-nowrap">{item.amount}</div>
              </div>
            ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProjectsListModal;
